import { report } from '../../interfaces'

interface props {
  setShowReportModal: React.Dispatch<React.SetStateAction<boolean>>
  singleReport: report | null
}

const ReportModal = ({ setShowReportModal, singleReport }: props) => {
  return (
    <>
      <div id='reportDetailModal' className='modal'>
        <div className='modal-content grid justify-items-center rounded-md'>
          <p className='text-center text-xl'>
            Tecnico: {singleReport!.creator_name}
          </p>
          <p className='text-center text-xl'>Tipo: {singleReport!.kind_name}</p>
          <p className='text-center text-xl'>
            Cliente: {singleReport!.client_name}
          </p>
          {singleReport?.client_phone && (
            <>
              <p className='text-center text-xl'>
                Telefono: {singleReport!.client_phone}
              </p>
              <p className='text-center text-xl'>
                Correo: {singleReport!.client_email}
              </p>
            </>
          )}
          <p className='text-center text-xl'>
            Método de Pago: {singleReport!.method}
          </p>
          <p className='text-center text-xl'>
            Monto Cobrado: {singleReport!.amount}
          </p>
          <p className='text-center text-xl'>
            Direccion: {singleReport!.client_address}
          </p>
          <p className='text-center text-xl'>
            Detalles: {singleReport!.details}
          </p>
          <p className='text-center text-xl'>Fecha: {singleReport!.date}</p>
          <button
            className='bg-red-400  text-white text-xl rounded-lg px-8 py-2 mt-10 shadow-lg'
            onClick={() => setShowReportModal(false)}>
            <span>Cerrar</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default ReportModal
